module.exports = __webpack_public_path__ + "site-build/img/logo_name.f9bb54f6.svg";